import template from
    '../../../templates/payroll/stepThree/BatchPaymentConfig.ejs';
import FormView from 'commons/views/Form';
import Log from 'lib/log';

const log = Log('batch-payment-config-view');

module.exports = FormView.extend({
    events: function() {
        var parentEvents = _.isFunction(FormView.prototype.events) ?
            FormView.prototype.events() : FormView.prototype.events;

        return _.extend(_.clone(parentEvents), {
            'ifToggled .js-ext-enable': 'toggleFormFields'
        });
    },

    initialize: function(options) {
        this.options = _.defaults(options || {}, {template: template});
        this.options.templateExtra =
            _.defaults(this.options.templateExtra || {}, {
                supported: this.options.supported
            });

        return FormView.prototype.initialize.apply(this, [this.options]);
    },

    toggleFormFields: function(ev) {
        var $toggle = this.$(ev.currentTarget);

        if (!$toggle.is(':checked')) {
            this.$('form input').each((i, el) => {
                if (el !== $toggle[0]) {
                    this.$(el).prop('disabled', true);
                }
            });
        } else {
            this.$('form input').prop('disabled', false);
        }

        this.toggleError();
    },

    dirty: function() {
        return false;
    },

    save: function() {
        if (!this.getInputValue(this.$('.js-ext-enable'))) {
            log.debug('Not saving batch payment config. Disabled by user');
            return Promise.resolve();
        }

        if (!this.options.supported) {
            log.debug('Not saving batch payment config. Not supported by bank');
            return Promise.resolve();
        }

        return this.model.save();
    }
});



// WEBPACK FOOTER //
// ./app/employer/views/payroll/stepThree/BatchPaymentConfig.js